import React, { useState, useRef, useEffect } from 'react'
import moment from 'moment'
import { Button } from 'antd'
import { ShrinkOutlined } from '@ant-design/icons'
import { CallStatusString, CallInfo } from 'src/types/ai-assistant'
import { maskPhone } from '@library'

interface TitleProps {
  callStatus: CallStatusString
  callInfo: CallInfo
  handleMinimize: () => void
}

const Title = ({ callStatus, callInfo, handleMinimize }: TitleProps) => {
  const [callingSeconds, setCallingSeconds] = useState(0)
  const [talkingSeconds, setTalkingSeconds] = useState(0)
  const intervalCallingSecondsRef = useRef<NodeJS.Timeout | null>(null)
  const intervalTalkingSecondsRef = useRef<NodeJS.Timeout | null>(null)
  useEffect(() => {
    if (callInfo && callInfo.callTimestamp) {
      const timestamp = callInfo.callTimestamp
      const now = Date.now() // 当前时间戳
      const diffInSeconds = Math.floor((now - timestamp) / 1000)
      setTalkingSeconds(diffInSeconds)
    }
  }, [callInfo])
  useEffect(() => {
    intervalCallingSecondsRef.current = setInterval(() => {
      setCallingSeconds(prev => prev + 1)
    }, 1000)
    return () => {
      intervalCallingSecondsRef.current && clearInterval(intervalCallingSecondsRef.current)
      intervalCallingSecondsRef.current = null
      setCallingSeconds(0)
    }
  }, [])

  useEffect(() => {
    if (callStatus === 'talking') {
      setCallingSeconds(0)
      intervalCallingSecondsRef.current && clearInterval(intervalCallingSecondsRef.current)
      intervalCallingSecondsRef.current = null
      intervalTalkingSecondsRef.current = setInterval(() => {
        setTalkingSeconds(prev => prev + 1)
      }, 1000)
    }
    return () => {
      intervalTalkingSecondsRef.current && clearInterval(intervalTalkingSecondsRef.current)
      intervalTalkingSecondsRef.current = null
      setTalkingSeconds(0)
    }
  }, [callStatus])
  return (
    <div className="title">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <span>{callStatus === 'calling' ? `呼叫中 ${moment.utc(moment.duration(callingSeconds, 'seconds').asMilliseconds()).format('HH:mm:ss')}` : `通话中 ${moment.utc(moment.duration(talkingSeconds, 'seconds').asMilliseconds()).format('HH:mm:ss')}`}</span>
          <div className="callee-info">
            <span>{maskPhone(callInfo.calleePhoneNumberText)}</span>
            <span style={{ marginLeft: 8 }}>{callInfo.calleeLocation}</span>
          </div>
          <span className="caller-number">主叫号码：{callInfo.callerPhoneNumberText}</span>
        </div>
        <Button
          icon={(<ShrinkOutlined />)}
          type="text"
          size="small"
          onClick={handleMinimize}
          style={{ border: '1px solid' }}
        />
      </div>
    </div>
  )
}

export default Title
